import { Stack } from '@mui/material';
import { EffectiveLocationPolicy } from '../../../GeneratedClient';
import { ActionDefinitionsTab } from './PolicyConfiguration/ActionDefinitionsTab';
import { CasePolicyTab } from './PolicyConfiguration/CasePolicyTab';
import { CustomFamilyFieldsTab } from './PolicyConfiguration/CustomFamilyFieldsTab';
import { V1ReferralPolicyTab } from './PolicyConfiguration/V1ReferralPolicyTab';
import { VolunteerPolicyTab } from './PolicyConfiguration/VolunteerPolicyTab';
import { OrganizationPolicyTab } from './PolicyConfiguration/OrganizationPolicyTab';

type PolicyConfigurationProps = {
  policy: EffectiveLocationPolicy;
  locationRoles: string[];
  onPolicyChange: (policy: EffectiveLocationPolicy) => Promise<boolean>;
  section:
    | 'actionDefinitions'
    | 'customFamilyFields'
    | 'casePolicy'
    | 'v1ReferralPolicy'
    | 'volunteerPolicy'
    | 'organizationPolicy';
};

const tableBasedSections = new Set<PolicyConfigurationProps['section']>([
  'actionDefinitions',
  'customFamilyFields',
  'casePolicy',
  'v1ReferralPolicy',
  'volunteerPolicy',
  'organizationPolicy',
]);

export function PolicyConfiguration({
  policy,
  locationRoles,
  onPolicyChange,
  section,
}: PolicyConfigurationProps) {
  const isTableBasedSection = tableBasedSections.has(section);

  return (
    <Stack
      spacing={2}
      sx={{
        maxWidth: isTableBasedSection ? undefined : 1200,
        minWidth: 0,
        pb: 4,
        width: '100%',
      }}
    >
      {section === 'actionDefinitions' && (
        <ActionDefinitionsTab policy={policy} onPolicyChange={onPolicyChange} />
      )}
      {section === 'customFamilyFields' && (
        <CustomFamilyFieldsTab
          policy={policy}
          onPolicyChange={onPolicyChange}
        />
      )}
      {section === 'casePolicy' && (
        <CasePolicyTab
          policy={policy}
          locationRoles={locationRoles}
          onPolicyChange={onPolicyChange}
        />
      )}
      {section === 'v1ReferralPolicy' && (
        <V1ReferralPolicyTab
          policy={policy}
          locationRoles={locationRoles}
          onPolicyChange={onPolicyChange}
        />
      )}
      {section === 'volunteerPolicy' && (
        <VolunteerPolicyTab policy={policy} onPolicyChange={onPolicyChange} />
      )}
      {section === 'organizationPolicy' && (
        <OrganizationPolicyTab
          policy={policy}
          onPolicyChange={onPolicyChange}
        />
      )}
    </Stack>
  );
}
